// src/components/Navbar.js
import React from 'react';
import styled from 'styled-components';
import { HashLink } from 'react-router-hash-link';




const NavbarWrapper = styled.nav`
  position: fixed;
  top: 0;
  //background-color: rgba(0, 0, 0, 1) ;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(15px);
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width:100%;
  z-index: 1000;

`;

const Logo = styled.a`

`;

const LogoImage = styled.img`
  height: 36px; 
  width: 240px;
  margin-left: 15%;


  @media (max-width: 500px) {
    margin-left: 5%;
    height: 30px;
    width: 180px;
  
  }
`;



const NavLinks = styled.div`
  display: flex;
  gap: 36px;
  justify-content: center; /* 讓連結在水平方向正中間 */
  align-items: center; /* 讓連結在垂直方向正中間 */
  flex-grow: 1; /* 讓 NavLinks 填滿 Navbar 的剩餘空間 */
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 100px; /* 圓角框的半徑 */
  padding:8px 20px; 
  max-width:30%;
  margin: 0 auto;
  background-color:rgba(255, 255, 255, 0.05);



  @media (max-width: 500px) {
    display: none; /* 在小於 500px 寬度時隱藏 NavLinks */
  }
`;

const NavLink = styled.a`
  color: #FFFFFF;
  text-decoration: none;
  font-size:18px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  //padding: 10px 15px;
  



  &:hover {
    
    color: #FFF56A;
  }
`;

const MobileMenuButton = styled.div`
  display: flex
  cursor: pointer;
  color: white;
  font-size: 1.2em;
  margin-right: 5%;
  

  @media (max-width: 500px) {
    display: block;
  }
  @media (min-width: 501px) {
    display: none; /* 在大於 500px 寬度時隱藏 MobileMenu */
  }
`;

const MobileMenu = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 1); // 半透明黑色背景
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1px;
  overflow-y: auto;
  z-index: 999;
`;

const CloseButton = styled.div`
  position: absolute;
  top: 5%;
  right: 5%;
  cursor: pointer;
  color: white;
  font-size: 1.5em;

  @media (max-width: 500px) {
    top: 1%;
    right: 5%;
  }
`;

const MobileMenuItem = styled.a`
  color: white;
  text-decoration: none;
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 35px;
  padding: 10px;
  display: flex;
  flex-direction: column; /* 使文本垂直排列 */
  align-items: center;

  &:hover {
    
    color: #FFF56A;
  }

  @media (max-width: 500px) {
    font-size: 24px;
    line-height: 25px;
  }

`;

const SubText = styled.span`
  color: white;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 0px;

  @media (max-width: 500px) {
    font-size: 8px;
  }
`;


const MobileMenuItem_node = styled.a`
  color: #FFF56A;
  text-decoration: none;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 12px;
  padding: 10px;
  display: flex;
  align-items: center;

  @media (max-width: 500px) {
    font-size: 16px;
  }



`;

const MenuButton = styled.div`
  display: flex
  cursor: pointer;
  color: white;
  font-size: 1.2em;
  margin-right: 5%;
  

  @media (max-width: 500px) {
    display: none; /* 在小於 500px 寬度時隱藏 MobileMenu */
  }

`;




function Navbar() {
  const [isOpen, setIsOpen] = React.useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };



  return (
    <NavbarWrapper>
      <Logo href="/">
        <LogoImage src="/images/navi_logo.png" alt="MyLogo" />
      </Logo>
      <NavLinks>
        <NavLink href="/did">DID</NavLink>
        <NavLink href="/dao">DAO</NavLink>
        <NavLink href="/retropgf">RetroPGF</NavLink>
        <NavLink href="/web3">web3</NavLink>
        <NavLink href="/info">相關資訊</NavLink>
        
        
      </NavLinks>
      <MenuButton onClick={toggleMenu}>
        <img src="/images/menu_pc.png" alt="Menu" />
      </MenuButton>
     
      <MobileMenuButton onClick={toggleMenu}>
        <img src="/images/menu_pc.png" alt="Menu" />
      </MobileMenuButton>
      <MobileMenu isOpen={isOpen}>
        <CloseButton onClick={closeMenu}>✕</CloseButton>
        <MobileMenuItem  href="/">首頁</MobileMenuItem>
        <MobileMenuItem_node>•</MobileMenuItem_node>
        <MobileMenuItem href="/did" dangerouslySetInnerHTML={{ __html: '分散式身分DID<br/><span style="font-size: 12px;">Decentralized Identity</span>' }} />
        <MobileMenuItem_node >•</MobileMenuItem_node>
        <MobileMenuItem href="/dao" dangerouslySetInnerHTML={{ __html: '分散式自治組織DAO<br/><span style="font-size: 12px;">Decentralized Autonomous Organization</span>' }} />
        <MobileMenuItem_node >•</MobileMenuItem_node>
        <MobileMenuItem href="/retropgf" dangerouslySetInnerHTML={{ __html: '回溯性公共投資RetroPGF<br/><span style="font-size: 12px;">Retroactive Public Goods Funding</span>' }} />
        <MobileMenuItem_node >•</MobileMenuItem_node>
        <MobileMenuItem href="/web3" dangerouslySetInnerHTML={{ __html: 'web3發展建議<br/><span style="font-size: 12px;">web3.0</span>' }} />
        <MobileMenuItem_node >•</MobileMenuItem_node>
        <MobileMenuItem href="/info">相關資訊</MobileMenuItem>
      </MobileMenu>
    </NavbarWrapper>
  );
}

export default Navbar;
